import ace from 'ace-builds';
import { addOpacityToHex, mixColors } from '../utils';
import token from './codeTokens';

// base colors inlined (enki's theme does not export `base`)
const base = {
  dark: '#121212',
  light: '#FAFAFA',
  gray: '#A1A1AA',
  grayDark: '#71717A',
};

const bgSurfaceActive = mixColors(base.dark, base.light, 0.15);
const border = addOpacityToHex(base.light, 0.1);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const aceAny = ace as any;

const cssText = `
.ace-enki .ace_gutter {
    background: transparent;
    color: ${base.grayDark}
}

.ace-enki .ace_print-margin {
    width: 1px;
    background: ${border}
}

.ace-enki {
    background-color: transparent;
    color: ${base.light}
}

.ace-enki .ace_cursor {
    color: #528bff
}

.ace-enki .ace_marker-layer .ace_selection {
    background: ${bgSurfaceActive}
}

.ace-enki.ace_multiselect .ace_selection.ace_start {
    box-shadow: 0 0 3px 0 ${base.dark};
    border-radius: 2px
}

.ace-enki .ace_marker-layer .ace_step {
    background: #c6dbae
}

.ace-enki .ace_marker-layer .ace_bracket {
    margin: -1px 0 0 -1px;
    border: 1px solid ${base.grayDark}
}

.ace-enki .ace_marker-layer .ace_active-line {
    background: ${addOpacityToHex(base.light, 0.04)}
}

.ace-enki .ace_gutter-active-line {
    background-color: ${addOpacityToHex(base.light, 0.04)}
}

.ace-enki .ace_marker-layer .ace_selected-word {
    border: 1px solid ${bgSurfaceActive}
}

.ace-enki .ace_fold {
    background-color: ${token.func};
    border-color: ${base.light}
}

.ace-enki .ace_keyword {
    color: ${token.keyword}
}

.ace-enki .ace_keyword.ace_operator {
    color: ${token.keyword}
}

.ace-enki .ace_keyword.ace_other.ace_unit {
    color: ${token.number}
}

.ace-enki .ace_constant.ace_language {
    color: ${token.number}
}

.ace-enki .ace_constant.ace_numeric {
    color: ${token.number}
}

.ace-enki .ace_constant.ace_character {
    color: ${token.constant}
}

.ace-enki .ace_constant.ace_other {
    color: ${token.constant}
}

.ace-enki .ace_support.ace_function {
    color: ${token.func}
}

.ace-enki .ace_support.ace_constant {
    color: ${token.number}
}

.ace-enki .ace_support.ace_class {
    color: ${token.classType}
}

.ace-enki .ace_support.ace_type {
    color: ${token.classType}
}

.ace-enki .ace_storage {
    color: ${token.keyword}
}

.ace-enki .ace_storage.ace_type {
    color: ${token.keyword}
}

.ace-enki .ace_invalid {
    color: ${base.light};
    background-color: ${token.variable}
}

.ace-enki .ace_invalid.ace_deprecated {
    color: ${base.dark};
    background-color: ${token.number}
}

.ace-enki .ace_string {
    color: ${token.string}
}

.ace-enki .ace_string.ace_regexp {
    color: ${token.variable}
}

.ace-enki .ace_comment {
    font-style: italic;
    color: ${token.comment}
}

.ace-enki .ace_variable {
    color: ${token.variable}
}

.ace-enki .ace_variable.ace_parameter {
    color: ${token.number}
}

.ace-enki .ace_meta.ace_tag {
    color: ${token.variable}
}

.ace-enki .ace_entity.ace_other.ace_attribute-name {
    color: ${token.variable}
}

.ace-enki .ace_entity.ace_name.ace_function {
    color: ${token.func}
}

.ace-enki .ace_entity.ace_name.ace_tag {
    color: ${token.variable}
}

.ace-enki .ace_markup.ace_heading {
    color: ${token.string}
}

.ace-enki .ace_indent-guide {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWPQ09NrYAgMjP4PAAtGAwchHMyAAAAAAElFTkSuQmCC) right repeat-y
}

.ace-enki .ace_indent-guide-active {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQIW2PQ1dX9zzBz5sz/ABCcBFFentLlAAAAAElFTkSuQmCC) right repeat-y
}
`;

aceAny.define(
  'ace/theme/enki-css',
  ['require', 'exports', 'module'],
  function (_require: unknown, exports: Record<string, string>) {
    exports.cssText = cssText;
  }
);

aceAny.define(
  'ace/theme/enki',
  ['require', 'exports', 'module', 'ace/theme/enki-css', 'ace/lib/dom'],
  function (
    require: (path: string) => {
      importCssString: (css: string, cls: string, force: boolean) => void;
    },
    exports: Record<string, unknown>
  ) {
    exports.isDark = true;
    exports.cssClass = 'ace-enki';
    exports.cssText = cssText;
    const dom = require('../lib/dom');
    dom.importCssString(cssText, 'ace-enki', false);
  }
);

export const ACE_THEME = 'enki';
